import { render, staticRenderFns } from "./LastInstaPosts.vue?vue&type=template&id=59600c61&scoped=true&"
import script from "./LastInstaPosts.vue?vue&type=script&lang=js&"
export * from "./LastInstaPosts.vue?vue&type=script&lang=js&"
import style0 from "./LastInstaPosts.vue?vue&type=style&index=0&id=59600c61&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59600c61",
  null
  
)

export default component.exports